import Backbone from 'backbone';
import Mn from 'backbone.marionette';
import $ from 'jquery';
import CreateTenantView from './admin/create_tenant';
import AdminView from './admin/index';
import AdminModelsView from './admin/models';
import AdminTenantsView from './admin/tenants';
import app from './app';
import { getCurrentUser } from './auth/userContext';
import { initiateOAuthFlow } from './auth/oauth';

const AuthController = (Mn.Object as any).extend({
  initialize() {
    // Note: Keeping app.session temporarily for backward compatibility
    this.session = app.session;
  },

  async execute(callback: () => {}, args: { session: any }) {
    // Check if we're already redirecting to OAuth (prevent loop)
    if (sessionStorage.getItem('oauth_redirecting') === 'true') {
      return; // Don't execute callback, redirect is in progress
    }

    try {
      await getCurrentUser(); // Will throw if not authenticated

      if (callback) callback.apply(this, args);
    } catch (error) {
      // Not authenticated - redirect to OAuth
      const currentPath = window.location.pathname + window.location.search;
      if (currentPath.length > 1 && currentPath !== '/') {
        sessionStorage.setItem('oauth_redirect', currentPath);
      }
      initiateOAuthFlow();
      // Don't execute callback - redirect is happening
    }
  },

  change_title(title: string) {
    const newTitle = title ? `${title} | MadKudu` : 'HG Insights';
    $(document).attr('title', newTitle);
  },

  track_page(title: string) {
    return title && window.analytics && window.analytics.page(title);
  },

  async transition_view(View: any, options: { title?: string } = {}) {
    const { title } = options;
    const user = await getCurrentUser();

    if (!user.superKudu) {
      Backbone.history.navigate('error/404', { trigger: true });
      return;
    }

    this.track_page(title);
    this.change_title(title);

    app.root.showChildView(
      'main',
      // eslint-disable-next-line
      View.default ? new View.default(options) : new View(options)
    );
  },

  home() {
    this.transition_view(AdminView, { title: 'Admin' });
  },

  create_tenant() {
    this.transition_view(CreateTenantView, { title: 'Admin' });
  },

  list_tenants(currentPage: string) {
    this.transition_view(AdminTenantsView, {
      title: 'Admin',
      currentPage: Number(currentPage),
    });
  },

  list_models() {
    this.transition_view(AdminModelsView, {
      title: 'Live Models',
    });
  },
});

export default Mn.AppRouter.extend({
  execute(callback: () => {}, args: { session: any }, name: string) {
    this.controller.execute(callback, args, name);
    // if (callback) callback.apply(this, args)
  },
  appRoutes: {
    'admin(/)': 'home',
    'admin/tenant/create': 'create_tenant',
    'admin/tenant/list(?page=:page)': 'list_tenants',
    'admin/model/list': 'list_models',
  },

  initialize() {
    this.controller = new AuthController({});
  },
});
